import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d06c685"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2" }
const _hoisted_2 = { class: "action-chips mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pending manual entries", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Draft invoices", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Invalid hours", -1))
const _hoisted_6 = {
  key: 3,
  class: "action-chip static"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Telemetry backlog", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-color-secondary"
}
const _hoisted_9 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Recent pending entries", -1))
const _hoisted_11 = { class: "detail-list" }
const _hoisted_12 = { class: "text-color-secondary" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-color-secondary" }
const _hoisted_15 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_16 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Draft invoices", -1))
const _hoisted_18 = { class: "detail-list" }
const _hoisted_19 = { class: "text-color-secondary" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Recent invalid hours", -1))
const _hoisted_22 = { class: "detail-list" }
const _hoisted_23 = { class: "text-color-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Action queue" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showManual)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "action-chip",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go('manual-entries')))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["action-count", { hot: (_ctx.actions?.pending_manual_entries || 0) > 0 }])
            }, _toDisplayString(_ctx.actions?.pending_manual_entries ?? 0), 3),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      (_ctx.showInvoice)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "action-chip",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focus-settlement')))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["action-count", { hot: (_ctx.actions?.draft_invoices || 0) > 0 }])
            }, _toDisplayString(_ctx.actions?.draft_invoices ?? 0), 3),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_ctx.showPpm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "action-chip",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go('performance')))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["action-count", { hot: (_ctx.actions?.invalid_hours || 0) > 0 }])
            }, _toDisplayString(_ctx.actions?.invalid_hours ?? 0), 3),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTelemetry)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["action-count", { hot: ((_ctx.actions?.telemetry_pending || 0) + (_ctx.actions?.telemetry_failed || 0)) > 0 }])
            }, _toDisplayString((_ctx.actions?.telemetry_pending || 0) + (_ctx.actions?.telemetry_failed || 0)), 3),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasAnyDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Nothing waiting for attention. "))
      : _createCommentVNode("", true),
    (_ctx.showManual && _ctx.actions?.manual_entries_recent?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions.manual_entries_recent, (e) => {
              return (_openBlock(), _createElementBlock("li", {
                key: e.id,
                class: "detail-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(e.variable_name), 1),
                  _createElementVNode("span", _hoisted_12, " · " + _toDisplayString(e.period_name), 1),
                  (e.value != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " · " + _toDisplayString(e.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_14, " · " + _toDisplayString(e.submitted_by_username || '—'), 1)
                ]),
                (_ctx.canApproveManual)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _withDirectives(_createVNode(_component_PButton, {
                        disabled: _ctx.busyId === e.id,
                        loading: _ctx.busyId === e.id && _ctx.busyAction === 'approve',
                        icon: "pi pi-check",
                        rounded: "",
                        size: "small",
                        severity: "success",
                        onClick: ($event: any) => (_ctx.$emit('approve-entry', e.id))
                      }, null, 8, ["disabled", "loading", "onClick"]), [
                        [
                          _directive_tooltip,
                          'Approve',
                          void 0,
                          { top: true }
                        ]
                      ]),
                      _withDirectives(_createVNode(_component_PButton, {
                        disabled: _ctx.busyId === e.id,
                        loading: _ctx.busyId === e.id && _ctx.busyAction === 'reject',
                        icon: "pi pi-times",
                        outlined: "",
                        rounded: "",
                        size: "small",
                        severity: "danger",
                        onClick: ($event: any) => (_ctx.$emit('reject-entry', e.id))
                      }, null, 8, ["disabled", "loading", "onClick"]), [
                        [
                          _directive_tooltip,
                          'Reject',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showInvoice && _ctx.actions?.draft_invoices_list?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("ul", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions.draft_invoices_list, (inv) => {
              return (_openBlock(), _createElementBlock("li", {
                key: inv.id,
                class: "detail-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(inv.invoice_number || ('#' + inv.id)), 1),
                  _createElementVNode("span", _hoisted_19, " · " + _toDisplayString(inv.mode) + " · " + _toDisplayString(inv.generated_by || '—'), 1)
                ]),
                (_ctx.canApproveInvoice)
                  ? (_openBlock(), _createBlock(_component_PButton, {
                      key: 0,
                      disabled: _ctx.busyId === inv.id,
                      loading: _ctx.busyId === inv.id && _ctx.busyAction === 'approve-inv',
                      icon: "pi pi-check",
                      label: "Approve",
                      rounded: "",
                      size: "small",
                      severity: "success",
                      onClick: ($event: any) => (_ctx.$emit('approve-invoice', inv.id))
                    }, null, 8, ["disabled", "loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPpm && _ctx.actions?.invalid_hours_recent?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("ul", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions.invalid_hours_recent, (h, idx) => {
              return (_openBlock(), _createElementBlock("li", { key: idx }, [
                _createElementVNode("strong", null, _toDisplayString(h.hour_start || '—'), 1),
                _createElementVNode("span", _hoisted_23, " · " + _toDisplayString(h.invalid_reason || 'invalid'), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}